export default __webpack_public_path__ + "static/media/helpBanner.23e6888e.svg";